import React, { useEffect, useState } from "react";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import moment from "moment";
import { withRouter } from 'react-router-dom';
import './index.less';
import { ISubmitStatusId } from "../../submited";
import OriginWO from "./OriginWO";
import { Button } from 'oned';
var DuplicateOriginWOSubmitted = inject(ProblemBusiness)(observer(function (props) {
    var originWO = props.originWO, history = props.history;
    var _a = useState(originWO), woDetail = _a[0], setWoDetail = _a[1];
    var _b = useState(), currentStep = _b[0], setCurrentStep = _b[1];
    var _c = useState([
        { id: 1, name: "Request Submitted", completeTime: new Date() },
        { id: 2, name: "Technician Assigned", completeTime: '' },
        { id: 3, name: "Technician Scheduled", completeTime: '' },
        { id: 4, name: "Technician On-Site", completeTime: '' },
        { id: 5, name: "Completed", completeTime: '' },
    ]), steps = _c[0], setSteps = _c[1];
    useEffect(function () {
        InitStep();
    }, [OriginWO]);
    var InitStep = function () {
        if (!woDetail)
            return;
        var data = [];
        var _showStatusId = ISubmitStatusId.RequestSubmitted;
        data = steps.map(function (x) {
            if (x.id === 1) {
                x.completeTime = woDetail.CreateDate;
            }
            return x;
        });
        setSteps(data);
        setCurrentStep(_showStatusId);
    };
    var goHome = function () {
        history.push("/");
    };
    return React.createElement("div", { className: "rsp-boy" },
        React.createElement("div", { className: "rsp-step-header py-3" },
            React.createElement("div", { className: "rsp-step-back" }),
            React.createElement("h1", { className: "rsp-step-title rest-step-title font-weight-bolder" }, "Request submitted"),
            React.createElement("div", { className: "rsp-step-back" })),
        React.createElement("div", { className: "dsm-card" },
            React.createElement("div", { className: "dsm-card-body step-submitted-body" },
                React.createElement("h1", { className: "request-submitted-title font-weight-bolder" }, "We will review the additional details to the work order."),
                React.createElement("h1", { className: "request-submitted-title font-weight-bolder mt-3" }, "We value transparency. Here\u2019s a look into the process."),
                React.createElement("div", { className: "rsp-progress-bar py-4" },
                    React.createElement("div", { className: "rsp-step-progress" },
                        React.createElement("div", { className: "c-walkthru" },
                            React.createElement("div", { className: "dsm-walkthru dsm-walkthru-rsp dsm-walkthru-horizontal dsm-walkthru-auto-text" }, steps.map(function (item, index) {
                                var renderTimeLine = function (item, index) {
                                    return React.createElement(React.Fragment, null,
                                        React.createElement("div", { className: "dsm-walkthru-item " + (index === currentStep ? "dsm-walkthru-item-active" : "dsm-walkthru-item-wait") },
                                            React.createElement("div", { className: "dsm-walkthru-item-time " + (index !== currentStep ? 'opacity0' : '') },
                                                React.createElement("h5", { className: "font-weight-bolder mb-1" }, index === currentStep ? item.name : ''),
                                                currentStep !== ISubmitStatusId.TechnicianScheduled &&
                                                    React.createElement("div", { className: "f12 text-center mb-1" }, "You created"),
                                                React.createElement("div", { className: "f12 text-muted mb-1" }, moment(woDetail.createDate).format('MMM DD/YYYY, h:mm A'))),
                                            React.createElement("div", { className: "dsm-walkthru-line" }),
                                            React.createElement("div", { className: "dsm-walkthru-icon", "data-one-uiautomation": "button.rspDoneProgress.steps." + index }),
                                            React.createElement("div", { className: "dsm-walkthru-tail" }, index !== currentStep && item.name)));
                                };
                                return React.createElement(React.Fragment, null,
                                    currentStep === ISubmitStatusId.TechnicianScheduled && React.createElement(React.Fragment, null,
                                        [0, 1].includes(index) && React.createElement("div", { className: "dsm-walkthru-item dsm-walkthru-item-finished" },
                                            React.createElement("div", { className: "dsm-walkthru-item-time opacity0" },
                                                React.createElement("h5", { className: "font-weight-bolder mb-1" }),
                                                React.createElement("div", { className: "f12 text-center mb-1" }),
                                                React.createElement("div", { className: "f12 text-muted mb-1" })),
                                            React.createElement("div", { className: "dsm-walkthru-line" }),
                                            React.createElement("div", { className: "dsm-walkthru-icon", "data-one-uiautomation": "button.rspDoneProgress.steps." + index }),
                                            React.createElement("div", { className: "dsm-walkthru-tail" }, item.name)),
                                        index > 1 && renderTimeLine(item, index)),
                                    currentStep === ISubmitStatusId.RequestSubmitted && renderTimeLine(item, index));
                            }))))))),
        React.createElement("div", { className: "mt-3" },
            React.createElement(Button, { type: "primary", block: true, onClick: function () { return goHome(); } }, "Done")));
}));
export default withRouter(DuplicateOriginWOSubmitted);
